<template>
  <div class="ma-6">
    <h4
      class="text-center keycolumn ma-0 pt-4 pb-4"
      :class="{
        'primary--text': !$vuetify.theme.dark,
        'black--text': $vuetify.theme.dark,
      }"
    >
      Frequently Asked Questions
    </h4>
    <faq></faq>
  </div>
</template>
<script>
import faq from "../../pages/dashboard/faq.vue";
export default {
  components: {
    faq,
  },
};
</script>
